module.exports = __webpack_public_path__ + "img/stackslash-46-mobile.d422cca1.jpg";